<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-01 01:00:48
 * @Description: file content
-->
<template>
  <div class="bg">
    <div class="bgImg"></div>
    <BaseImg :option="{style: {'margin-top':'14px','margin-left':'16px',width: '71px','align-self': 'flex-start'},url: 'logo.png',}"/>
    <BaseImg :option="{style: {'margin':'27px auto 0',width: '100%',},url: 'slogan.png',}"/>

    <div class="pro-nav">
      <!-- <div :class="['nav',{big:item.name.length>6} ]" v-for="(item, index) in projectList.intro" :key="index" @click="chooseSignInfo(item.projectId)"> -->
      <div :class="['nav',{big:item.name.length>6||signInfoList.length%2==0} ]" v-show="item.signInfo.length" v-for="(item, index) in signInfoList" :key="index" @click="chooseSignInfo(index)">
          <div class="info" :class="{choose: chooseNavIndex == index,}" >
          {{item.name}}
        </div>
      </div>
      
    </div>
    <div class="act_list"  v-for="(item,index) in signInfo" :key="`index${index}`">
      <BaseImg :option="{style: {'margin':'0 auto',width: '100%',zIndex:1},url: 'sign_bg_1.png',}"/>
      <div class="act_box">
        <img class="title" :src="`${imgHost}sign/title_${item.signTitle}.png?v=${$config.OSSVersion}`" />
        <img class="line" :src="`${imgHost}sign/line.png?v=${$config.OSSVersion}`" />
        <p class="text"><span>活动时间：</span>{{item.time}}</p>
        <p class="text"><span>活动地址：</span>{{item.signAdd}}</p>
        <p class="text"><span>报名人数：</span>已报名人数<span style="color:#EE5D20">{{item.count}}人</span></p>
          <!-- /每组限<span style="color:#EE5D20">{{item.signNum}}人</span> -->
        <p class="text" v-show="item.info"><span>活动内容：</span>{{item.info}}</p>

        <div :class="['sign_up',{grayscale:item.hadDone} ]" @click="signUp(item)">
          报名参加
        </div>
      </div>
      <BaseImg :option="{style: {'margin':'0 auto',width: '100%',},url: 'sign_bg_3.png',}"/>
    </div>

      <!-- <div class="sign_box">
        <img class="title" :src="`${imgHost}sign/title.png?v=${$config.OSSVersion}`" />
        
        <div class="sign-list">
          <div class="list-item" v-for="(item, index) in sign_list" :key="index" >
            <div class="head-img">
              <img :src="item.headImg" alt="">
            </div>
            <div class="name">{{item.nickName}}</div>
          </div>
          <div class="no-data" v-if="sign_list.length === 0">暂无好友助力~</div>
        </div>
      </div> -->
      
    <div class="sign-list-box">
      <img class="title" :src="`${imgHost}sign/title.png?v=${$config.OSSVersion}`" />
      <div class="sign-list">
        <div class="list-item" v-for="(item, index) in signList" :key="index" >
          <div class="left">
            <div class="head-img">
              <img :src="item.headImg" alt="">
            </div>
            <div class="name">{{item.nickName}}</div>
          </div>
          <div>{{item.logTime}}</div>
        </div>
        <div class="no-data" v-if="signList.length === 0">暂无用户报名~</div>
      </div>
      <div class="tips" v-if="signList.length > 7">向上滑动查看更多</div>
    </div>
    <BaseBtnHome/>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return { 
      projectList:[],
      chooseAddressIndex:0,
      signInfo:[],
      sign_list:[],
      
      areaId: null,
      signInfoList: [
      ],
      chooseSignInfoList: [],
      // signInfo: {},
      signList: [],
      chooseNavIndex: 0,
      signNavList: [
      ],
      chooseSignNavList: [],
    }
  },
  computed: {},
  watch: {},
  mounted() {
    console.log(this.$infoId)
    // this.chooseAddress()
  },
  async created() {
    this.areaId =this.$route.query.areaId 
    await this.chooseAddress()
    await this.getApplyInfo()
    // this.recommendList()
  },
  methods: {
    // 页面埋点
    infoClick(sceneKey) {
      this.$httpdf.get(this.apiHost + 'info/click', { sceneKey: sceneKey })
    },
    async getApplyInfo() {
      const data = await this.$httpdf.get(`${this.apiHost}apply/applyInfos`,{pageGroup:parseInt(this.chooseAddressIndex)+1})
      if(data.code == 0) {
        let signInfoList = this.projectList.intro.map(item => {
          data.data.map(v => {
            if(item.id === v.id) {
              // item = {...item, ...v}
              item.signInfo=item.signInfo.map(i=>{
                return {...i,...v}
              })
            }
          })
          return item
        })
        console.log(signInfoList)
        this.$set(this, 'signInfoList', signInfoList)
        this.chooseSignInfo(0)
      }
    },
    async recommendList() {
      const data = await this.$httpdf.get(`${this.apiHost}apply/applyLogs`, {
        limit: 30,
        applyId:this.signInfo[0].id
      })
      if(data.code == 0) {
        this.signList = data.data
        let s=data.data.filter(v=> v.openid==this.$openid)
        console.log(s)
      }
    },
    // 获取城市对应的项目列表
    async getProjectList() {
      this.chooseSignNavList = this.signNavList.filter(v => v.areaId == this.areaId)
      let projectId = this.chooseSignNavList[this.chooseNavIndex].projectId
      this.chooseProject(projectId)
    },
    chooseAddress() {
      let chooseAddressIndex=0;
      // if([556,557,558,559].includes(this.$infoId)){
      //   chooseAddressIndex=0
      // }else if([560,561,562].includes(this.$infoId)){
      //   chooseAddressIndex=1
      // }else if([563,564].includes(this.$infoId)){
      //   chooseAddressIndex=2
      // }else if([565,566,567,568].includes(this.$infoId)){
      //   chooseAddressIndex=3
      // }else if([569,570,571,572].includes(this.$infoId)){
      //   chooseAddressIndex=4
      // }else if([573,574].includes(this.$infoId)){
      //   chooseAddressIndex=5
      // }

      chooseAddressIndex=this.$config.addressList.findIndex(v => v.areaId.includes(this.$infoId))
      
      console.log(chooseAddressIndex)
      this.chooseAddressIndex=chooseAddressIndex;
      this.projectList=this.$config.projectList[chooseAddressIndex]
    },
    chooseSignInfo(index){
      this.chooseNavIndex=index
      this.signInfo = this.signInfoList[index].signInfo
      this.recommendList()
    },
    // 报名
    async signUp(item) {
      console.log(item)
      if(item.hadDone==1){
        this.$showModal("您已报名该项目!");
        return 
      }
      this.infoClick(15)
      this.$modal.drawForm.alert({
        isSignUp: true,
        drawTxt: 2,
        projectId: item.extraId || item.projectId,
        applyId: item.id
      }).then(async(res) => {
        console.log(res)
        // if(res.flag == 'showCode') {
          // this.$modal.drawForm.alert({
          //   isCode: true,
          //   drawTxt: 4,
          //   qrCode: res.qrCode
          // })
        // }
        await this.getApplyInfo()
      })
    },
  },
};
</script>

<style lang="scss" scoped>
div{
  position: relative;
}
.grayscale{
  filter: grayscale(100%);

  -webkit-filter: grayscale(100%);

  -moz-filter: grayscale(100%);

  -ms-filter: grayscale(100%);

  -o-filter: grayscale(100%);

  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);

  -webkit-filter: grayscale(1);
}
.bg {
  padding-bottom:40px;
  background: linear-gradient(0deg, #FCC229 0%, #FDD142 49%, #FDD94F 100%);
  .bgImg{
    position: absolute;
    z-index:0;
    width: 343px;
    background-image: url( $imgHost + 'bg.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    border: 1px solid #231815;
    border-radius: 0px 0px 62px 0px;
    top:51px;
    bottom:40px;
  }
  .pro-nav {
    margin-top:15px;
    width:330px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .nav {
      position: relative;
      height: 28px;
      width:94px;
      background: #231815;
      border: 1px solid #231815;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #231815;
      margin-bottom:14px;
      //&:nth-child(1),&:nth-child(4),&:nth-child(7) {
      //  margin-left:0;
      //}
      &.big{
        width:127px;
      }
      .info{
        position: absolute;
        width:100%;
        height: 28px;
        top:-3px;
        left:-3px;
        background: #FCCE3E;
        border: 1px solid #2F0005;
        border-radius: 4px;
        @extend .flex-center-center;
        &.choose {
          font-weight: bold;
          color: #FFFFFF;
          background: #EE5D20;
          border: 1px solid #2F0005;
          border-radius: 4px;
          &:after {
            background: linear-gradient(-90deg, #F7C17A 0%, rgba(247,193,122,0) 100%);
          }
        }
      }
    }
  }
  .act_list{
    margin-top:16px;
    .act_box{
      position: relative;
      width: 100%;
      background: url( $imgHost + 'sign_bg_2.png?v=' + $OSSVersion) 0 0 / 100% repeat;
      .title{
        margin-top:-20px;
        z-index:2;
        position: relative;
      }
      .line{
        margin:8px 49px 0;
        width:277px;
      }
      .text{
        color:#221715;
        font-size:13px;
        color: #221715;
        line-height: 22px;
        margin:0 62px;
        width:250px;

        span{
          font-weight: bold;
        }
      }
      .sign_up{
        width:262px;
        height:62px;
        line-height: 58px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #201715;
        letter-spacing: 7px;
        padding-left:10px;
        margin-left:56px;
        margin-top:26px;
        background: url( $imgHost + 'btn_bg.png?v=' + $OSSVersion) 0 0 / 100% repeat;
      }
    }
  }
  .sign_box{
    margin-top:24px;
    position: relative;
    width: 100%;
    height:435px;
    background: url( $imgHost + 'userList_bg.png?v=' + $OSSVersion) 0 0 / 100% repeat;
    .title{
      margin-top:48px;
      width:100%;
    }
    
    .friends-list {
      width:271px;
      height: 300px;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      margin: 0 auto;
      z-index: 2;
      .list-item {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2D2D2D;
        padding: 10px 0;
        &+.list-item {
          border-top: 1px solid rgba(254, 228, 129, .2)
        }
        .rank {
          width: 30px;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fff;
          text-align: center;
        }
        .head-img {
          background: #fff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          // margin: 0 auto;
          position: relative;
          img {
            border-radius: 50%;
          }
        }
        .name {
          flex: 1;
          margin-left: 12px;
          span {
            font-size: 10px;
            opacity: 0.74;
          }
        }
        .txt {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FEE481;
          span {
            font-size: 18px;
            color: #FF4C1D;
          }
        }
        .score {
          margin-right: 25px; 
        }
        &.my-rank {
          .name {
            font-weight: 500;
          }
          .score {
            background: linear-gradient(0deg, #00C2FD 0.4150390625%, #00CDC6 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
  
  .sign-list-box {
    margin-top:24px;
    position: relative;
    width: 100%;
    height:435px;
    background: url( $imgHost + 'userList_bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    .title{
      margin-top:48px;
      width:100%;
    }
    .sign-list {
      width: 271px;
      height: 280px;
      margin-left:53px;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      z-index: 2;
      .list-item {
        position: relative;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #6A6362;
        line-height: 18px;
        padding: 8px 0;
        @extend .flex-center-center;
        justify-content: space-between;
        &::after {
          position: absolute;
          bottom: 0;
          left: 0;
          content: "";
          width: 100%;
          border-bottom: 1px solid rgba($color: #DDDDDD, $alpha: 0.44);
          transform: scaleY(0.5);
        }
        &:last-child {
          border-bottom: none;
          &::after {
            content: none;
          }
        }
        .left {
          @extend .flex-center-center;
          display: inline-flex;
        }
        .head-img {
          background: #fff;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          // margin: 0 auto;
          position: relative;
          img {
            border-radius: 50%;
          }
        }
        .name {
          flex: 1;
          color: #221715;
          margin-left: 12px;
          span {
            font-size: 10px;
            opacity: 0.74;
          }
        }
      }
    }
    .tips {
      margin-top: 10px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5C75F7;
      text-align: center;
    }
    .no-data {
      width: 100%;
      height: 100%;
      font-size: 15px;
      color: #2D2D2D;
      @extend .flex-center-center;
      text-align: center;
      line-height: 180%;
    }
  }
}
</style>
